import ApiService from '@/services/api';
import Car from '@/entities/Car';
import { EntityBuilder } from '@decahedron/entity';
import CarOption from '@/entities/CarOption';
import CarDamage from '@/entities/CarDamage';
import Bid from '@/entities/Bid';
import Purchase from '@/entities/Purchase';

let instance: CarService = null;

export default class CarService {
    apiService: ApiService = null;

    carsList: Car[] = null;

    constructor() {
        if (!instance) {
            this.apiService = new ApiService();
            instance = this;
        }

        return instance;
    }

    get list(): Car[] {
        if (!this.carsList) {
            this.carsList = [];
            this.getList().then((cars) => {
                this.carsList = cars;
            });
        }

        return this.carsList;
    }

    protected getList() {
        return this.apiService.get('cars')
            .then((response) => EntityBuilder.buildMany<Car>(Car, response.data));
    }

    listAll() {
        return this.apiService.get('cars?include_inactive=1')
            .then((response) => EntityBuilder.buildMany<Car>(Car, response.data));
    }

    get(uuid: string) {
        if (this.carsList) {
            const foundCar = this.carsList.find((car: Car) => car.id === uuid);
            if (foundCar) {
                return new Promise((resolve, reject) => resolve(foundCar));
            }
        }

        return this.apiService.get(`cars/${uuid}`)
            .then((response) => EntityBuilder.buildOne<Car>(Car, response.data));
    }

    bids(uuid: string) {
        return this.apiService.get(`bids?car_id=${uuid}`)
            .then((response) => EntityBuilder.buildMany<Bid>(Bid, response.data));
    }

    purchases(uuid: string) {
        return this.apiService.get(`purchases?car_id=${uuid}`)
            .then((response) => EntityBuilder.buildMany<Purchase>(Purchase, response.data));
    }

    save(car: Car) {
        if (car.id) {
            return this.apiService.put(`cars/${car.id}`, car.toJson())
                .then((response) => EntityBuilder.buildOne<Car>(Car, response.data));
        }

        return this.apiService.post('cars', car.toJson())
            .then((response) => EntityBuilder.buildOne<Car>(Car, response.data));
    }

    archive(car: Car) {
        return this.apiService.put(`cars/${car.id}/archive`);
    }

    props() {
        return this.apiService.get('cars/props')
            .then((props) => {
                const copy = props;
                copy.options = EntityBuilder.buildMany<CarOption>(CarOption, props.options);
                copy.damages = EntityBuilder.buildMany<CarDamage>(CarDamage, props.damages);

                return copy;
            });
    }

    markSold(soldCar: Car) {
        this.carsList.map((car: Car) => {
            if (soldCar.id === car.id) {
                car.markSold();
            }
            return car;
        });
    }
}
